import { render, staticRenderFns } from "./targets.vue?vue&type=template&id=5538253a&"
import script from "./targets.vue?vue&type=script&lang=js&"
export * from "./targets.vue?vue&type=script&lang=js&"
import style0 from "./targets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports